import * as React from 'react';
import { SVGProps } from 'react';

const IconCardsCompactSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 6h8v5H3V6ZM3 13h8v5H3v-5ZM13 6h8v5h-8V6ZM13 13h8v5h-8v-5Z" />
  </svg>
);
export default IconCardsCompactSizeM;
